import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8fdfc4f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tb_head" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["src"]

import { withDefaults, computed } from 'vue';
import { planV5, planV6 } from '@/assets';

interface Props {
  title: string;
  icon?: string;
  show?: boolean[];
}

const __default__ = { name: 'NextHead' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: { default: '' },
    icon: { default: '' },
    show: null
  },
  emits: ['click:updata'],
  setup(__props: any, { emit }) {

const props = __props as { title: string, icon: string, show?: boolean[] };



const showList = computed(() => props.show || []);

const clickBack = () => {
  emit('click:updata', props.title);
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "tb_item",
      onClick: clickBack
    }, [
      (props.icon)
        ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            "icon-class": props.icon
          }, null, 8, ["icon-class"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_2, _toDisplayString(props.title), 1),
      _createElementVNode("img", {
        class: "icon",
        src: _unref(showList)[props.title] ? _unref(planV5) : _unref(planV6)
      }, null, 8, _hoisted_3)
    ])
  ]))
}
}

})